import React from "react";

export function FeaturedProjects() {
  return (
    <div className="fqxi-shortcodes-featuredProjects"></div>
  );
}
